'use client';

import type { BannerProps } from '@/core/types';

import React from 'react';

import { Box, Image, Button, Container, Typography } from '@/components/ui';

import { RouterLink } from '@/routes/components';

export default function BannerV1({
  title,
  titleTag = 'h2',
  subTitle,
  image,
  button,
  className = '',
}: BannerProps) {
  return (
    <div className={`${className} relative w-full`}>
      {!!image?.url && (
        <Image
          src={image?.url || ''}
          alt={image?.alt || ''}
          width={1440}
          height={800}
          objectFit="cover"
          className="w-full absolute top-0 left-0 h-full object-cover -z-[1]"
          loading="eager"
        />
      )}
      <Container className="flex md:items-center h-full relative z-10 min-h-[500px]">
        <Box className="max-w-[626px] pt-[76px] md:pt-[116px]">
          {title && (
            <Typography
              variant="h2"
              component={titleTag}
              className="max-w-[312px] md:max-w-none text-[32px] leading-[40px] md:text-[64px] md:leading-[80px] uppercase text-white font-bold mb-4"
            >
              {title}
            </Typography>
          )}
          {subTitle && (
            <Typography
              variant="body1"
              paragraph
              className="text-sm md:text-[24px] font-semibold text-white mb-[28px] md:mb-[36px]"
            >
              {subTitle}
            </Typography>
          )}
          {button && (
            <Button
              component={RouterLink}
              href={button.link}
              variant="contained"
              className="font-bold"
            >
              {button.text}
            </Button>
          )}
        </Box>
      </Container>
    </div>
  );
}
